/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";

import { Table } from "@nordcloud/gnui";

import { Maybe } from "~/tools";
import { EnvSelectorRow } from "./EnvSelectorRow";
import { Environment } from "./utils";

type Application = {
  nid: string;
  name: string;
  environments?: Maybe<Maybe<Environment>[]>;
};

type Props = {
  selectedAllEnvironments: boolean;
  filteredApps: Application[];
  envs: Maybe<Environment>[];
  setEnvs: React.Dispatch<React.SetStateAction<Maybe<Environment>[]>>;
  envsToRemove: Maybe<Environment>[];
  setEnvsToRemove: React.Dispatch<React.SetStateAction<Maybe<Environment>[]>>;
};

export function AttachEnvsTable({
  selectedAllEnvironments,
  filteredApps,
  envs,
  setEnvs,
  envsToRemove,
  setEnvsToRemove,
}: Props) {
  return (
    <Table
      small
      css={
        selectedAllEnvironments ? { opacity: "40%", pointerEvents: "none" } : {}
      }
    >
      {filteredApps?.map((application) => (
        <EnvSelectorRow
          key={application?.nid}
          name={application.name}
          environments={application?.environments ?? []}
          envs={envs ?? []}
          setEnvs={setEnvs}
          envsToRemove={envsToRemove}
          setEnvsToRemove={setEnvsToRemove}
        />
      ))}
    </Table>
  );
}
